import type { RouteObject } from 'react-router';

import { PunchPage } from './PunchPage';

/**
 * The punch feature's routes, for the integrator to splice into
 * `app/router.tsx` **inside** `RequireAuth` → `RequirePinChanged` → the shell.
 *
 * It is the index route: the punch screen is what a worker opens the app for,
 * and W8's recovery states render at the same path rather than at one of their
 * own — a refusal a worker can dismiss with the back button is a refusal they
 * can lose.
 *
 * **Not lazy, and it is the only route that is not.** `SessionGate` wraps
 * `RouterProvider`, so the router does not exist until `POST /auth/refresh`
 * answers — a `lazy()` here is a fourth sequential round trip on a cold start,
 * before `GET /me/context` has even begun, on the one screen the product
 * exists for. Every worker lands here and the chunk is ~12 kB gzipped, so
 * D-17's bundle rule is satisfied by keeping the OTHER screens lazy.
 */
export const punchRoutes: RouteObject[] = [
  {
    index: true,
    Component: PunchPage,
  },
];

/** The integrator's import name in `app/router.tsx` is `punchRoutes`; this is the
 *  same array under the name every other feature exports. */
export const routes = punchRoutes;
